var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-tabs',{attrs:{"value":_vm.selectedTab}},[_c('vs-tab',{attrs:{"label":_vm.tabs[0].label}},[_c('check-government')],1),_c('vs-tab',{attrs:{"label":_vm.tabs[1].label}},[_c('state-government')],1),_c('vs-tab',{attrs:{"label":_vm.tabs[2].label}},[_c('monitor-government')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }